const YES = 'Yes'
const NO = 'No'

export const q0 = {
    text: 'Ist dir Wasser sparen bei der Pflanzenbewässerung wichtig?',
    text_EN: 'Is water saving important for you when irrigating the garden?',
    type: 'options',
    answer: null,
    optionsFullWidth: false,
    settingsKey: 'waterSavingMode',
    options: [
        {
            label: YES,
            value: true,
            nextQuestion: 1,
        },
        {
            label: NO,
            value: false,
            nextQuestion: 1,
        },
    ],
}

export const q1 = {
    text: 'Die Bewässerung sollte so angepasst werden, dass das Pflanzenwachstum optimiert wird, egal wie viel Wasser dabei verbraucht wird.',
    text_EN: 'Watering process should be adapted so that the plants grow best, no matter how much water this demands?',
    type: 'options',
    answer: null,
    optionsFullWidth: false,
    settingsKey: 'bestGrowingMode',
    options: [
        {
            label: YES,
            value: true,
            nextQuestion: 2,
        },
        {
            label: NO,
            value: false,
            nextQuestion: 2,
        },
    ],
}

export const q2 = {
    text: 'Soll der Bewässerungsprozess automatisiert werden?',
    text_EN: 'Watering process should be automated',
    type: 'options',
    answer: null,
    optionsFullWidth: false,
    settingsKey: 'automatic_mode',
    options: [
        {
            label: YES,
            value: true,
            nextQuestion: 5,
        },
        {
            label: NO,
            value: false,
            nextQuestion: 3,
        },
    ],
}

export const q3 = {
    text: 'Die Bewässerung sollte starten, wenn die Feuchtigkeit unter eine bestimmte Grenze fällt, auch wenn es in ein paar Stunden regnet.',
    text_EN: 'Irrigation should just start when moisture is below a threshold, independent from possible rain in a few hours',
    type: 'options',
    answer: null,
    optionsFullWidth: false,
    settingsKey: 'reactive_mode',
    options: [
        {
            label: YES,
            value: true,
            nextQuestion: 4,
        },
        {
            label: NO,
            value: false,
            nextQuestion: 4,
        },
    ],
}

export const q4 = {
    text: 'Ich möchte keine Automatisierung der Bewässerung, stattdessen bevorzuge ich ... ',
    text_EN: 'I do not want the irrigation to be automated, I prefer ... ',
    type: 'options',
    answer: null,
    optionsFullWidth: true,
    settingsKey: 'alternative_mode',
    options: [
        {
            label: 'eine zeitbasierte Bewässerung',
            label_EN: 'an irrigation that is executed by time',
            value: 'time-scheduled',
            nextQuestion: 5,
        },
        {
            label: 'eigenständig zu gießen',
            label_EN: 'watering by myself',
            value: 'manual',
            nextQuestion: 5,
        },
    ],
}

export const q5 = {
    text: 'Möchtest du eine maximale Bewässerungszeit festlegen?',
    text_EN: 'I want to set a maximum watering time.',
    type: 'options',
    answer: null,
    optionsFullWidth: false,
    options: [
        {
            label: YES,
            value: true,
            nextQuestion: 6,
        },
        {
            label: NO,
            value: false,
            nextQuestion: 7,
        },
    ],
}

export const q6 = {
    text: 'Wie lange soll die maximale Bewässerungszeit sein?',
    text_EN: 'Maximum watering time should be:',
    type: 'minutes',
    answer: null,
    optionsFullWidth: true,
    settingsKey: 'maxWateringTime',
    options: [
        {
            label: 'Bestätigen',
            label_EN: 'Confirm',
            value: null,
            nextQuestion: 7,
        },
    ],
}

export const q7 = {
    text: 'Normalerweise gieße ich meine Pflanzen ... ',
    text_EN: 'Normally I water my plants ... ',
    type: 'options',
    answer: null,
    optionsFullWidth: true,
    settingsKey: 'wateringTime',
    options: [
        {
            label: 'abends / nach Sonnenuntergang',
            label_EN: 'in the evening / after sunset',
            value: 'sunset',
            nextQuestion: 9,
        },
        {
            label: 'morgens / vor dem Sonnenaufgang',
            label_EN: 'in the morning / before sunrise',
            value: 'sunrise',
            nextQuestion: 9,
        },
        {
            label: 'zu einer bestimmten Zeit',
            label_EN: 'at a specific time',
            value: 'specific-time',
            nextQuestion: 8,
        },
    ],
}


export const q8 = {
    text: 'Zu welcher Zeit gießt du?',
    text_EN: 'I water my plants at:',
    type: 'time',
    answer: null,
    optionsFullWidth: true,
    settingsKey: 'wateringTimeAt',
    options: [
        {
            label: 'Bestätigen',
            label_EN: 'Confirm',
            value: null,
            nextQuestion: 9,
        },
    ],
}

export const q9 = {
    text: 'Normalerweise gieße ich für ...',
    text_EN: 'Regularly, I water my plants for ...',
    type: 'minutes',
    answer: null,
    optionsFullWidth: true,
    settingsKey: 'wateringDuration',
    options: [
        {
            label: 'Bestätigen',
            label_EN: 'Confirm',
            value: null,
            nextQuestion: 10,
        },
    ],
}

export const q10 = {
    text: 'Möchtest du benachrichtigt werden, wenn Frost vorausgesagt ist, um die Geräte und Leitungen zu schützen?',
    text_EN: 'I want to receive frost warnings so that I can turn off water and protect the pipes',
    type: 'options',
    answer: null,
    optionsFullWidth: false,
    settingsKey: 'frostWarnings',
    options: [
        {
            label: YES,
            value: true,
            nextQuestion: 11,
        },
        {
            label: NO,
            value: false,
            nextQuestion: 11,
        },
    ],
}

export const q11 = {
    text: 'Möchtest du im Urlaub Benachrichtiungen erhalten?',
    text_EN: 'I want to receive notifications in vacation',
    type: 'options',
    answer: null,
    optionsFullWidth: false,
    settingsKey: 'vacationNotifications',
    options: [
        {
            label: YES,
            value: true,
            nextQuestion: 12,
        },
        {
            label: NO,
            value: false,
            nextQuestion: 12,
        },
    ],
}

export const q12 = {
    text: 'Möchtest du benachrichtigt werden, wenn der gemessene Feuchtigkeitswert zu niedrig ist?',
    text_EN: 'I want to receive notifications when moisture level is possibly too low.',
    type: 'options',
    answer: null,
    optionsFullWidth: false,
    settingsKey: 'notificationMoistureLow',
    options: [
        {
            label: YES,
            value: true,
            nextQuestion: 13,
        },
        {
            label: NO,
            value: false,
            nextQuestion: 13,
        },
    ],
}

export const q13 = {
    text: 'Möchtest du benachrichtigt werden, wenn der gemessene Feuchtigkeitswert zu hoch ist?',
    text_EN: 'I want to receive notifications when moisture level is possibly too high.',
    type: 'options',
    answer: null,
    optionsFullWidth: false,
    settingsKey: 'notificationMoistureHigh',
    options: [
        {
            label: YES,
            value: true,
            nextQuestion: null,
        },
        {
            label: NO,
            value: false,
            nextQuestion: null,
        },
    ],
}

export const questions = [
    q0,
    q1,
    q2,
    q3,
    q4,
    q5,
    q6,
    q7,
    q8,
    q9,
    q10,
    q11,
    q12,
    q13,
]



// WEBPACK FOOTER //
// ./src/constants/questions.js